module.exports = __webpack_public_path__ + "static/media/h6.0c3d6bfa.png";